module.exports = __webpack_public_path__ + "img/a11a0b6.png";